/* ORIIVE FLOW — page produit dédiée : variantes, prix, galerie, panier, CTA sticky.
   Vanilla JS, aucune dépendance. Progressive enhancement (le formulaire marche sans JS). */
(function () {
  'use strict';
  var root = document.querySelector('.offl-buy');
  if (!root) return;

  var form = root.querySelector('[id="offl-form"]');
  var variantInput = root.querySelector('[data-offl-variant-id]');
  var variantsEl = root.querySelector('[data-offl-variants]');
  var priceEl = root.querySelector('[data-offl-price]');
  var compareEl = root.querySelector('[data-offl-compare]');
  var saveEl = root.querySelector('[data-offl-save]');
  var atc = root.querySelector('[data-offl-atc]');
  var atcText = root.querySelector('[data-offl-atc-text]');
  var errEl = root.querySelector('[data-offl-error]');
  var slides = root.querySelectorAll('[data-offl-slide]');
  var thumbs = root.querySelectorAll('[data-offl-thumb]');
  var stickyPrice = root.querySelector('[data-offl-sticky-price]');
  var stickyLabel = root.querySelector('[data-offl-sticky-label]');
  var stickyBtn = root.querySelector('[data-offl-sticky-btn]');
  var sticky = root.querySelector('[data-offl-sticky]');

  var variants = [];
  try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }

  var LBL = {
    add: atc ? (atc.getAttribute('data-add') || atcText.textContent.trim()) : 'Ajouter au panier',
    sold: atc ? (atc.getAttribute('data-sold') || 'Épuisé') : 'Épuisé',
    unavailable: 'Combinaison indisponible'
  };

  // ---- Offres / bundles : palier sélectionné → variante pack (prix fixe réel) ou article à l'unité ----
  var currentQty = atc ? (parseInt(atc.getAttribute('data-offl-qty'), 10) || 1) : 1;
  var currentPieces = 1;          // nombre de pièces du palier (propriétés de ligne Pièce 1..N)
  var currentPackVariant = null;  // id de variante pack ; null = article à l'unité
  var currentPackPrice = '';      // prix affiché du pack (string money, rendu serveur)
  var currentGiftQty = 0; // culottes assorties ajoutées avec l'offre (gratuité = remise auto Shopify)
  var giftMap = null;
  try {
    var giftEl = root.querySelector('[data-offl-gift-variants]');
    if (giftEl) giftMap = JSON.parse(giftEl.textContent);
  } catch (e) { giftMap = null; }
  var lotImgMap = null;
  try {
    var lotEl = root.querySelector('[data-offl-gift-lot-images]');
    if (lotEl) lotImgMap = JSON.parse(lotEl.textContent);
  } catch (e) { lotImgMap = null; }

  // ---- Personnalisation par pièce (packs) : chaque pièce a sa couleur (+ taille en option) ----
  var piecesPanel = root.querySelector('[data-offl-pieces]');
  var piecesGrid = root.querySelector('[data-offl-pieces-grid]');
  var piecesCount = root.querySelector('[data-offl-pieces-count]');
  var piecesPalette = root.querySelector('[data-offl-pieces-palette]');
  var paletteTitle = root.querySelector('[data-offl-palette-title]');
  var paletteColors = root.querySelector('[data-offl-palette-colors]');
  var paletteSizes = root.querySelector('[data-offl-palette-sizes]');
  var sizesToggle = root.querySelector('[data-offl-sizes-toggle]');
  var piecesGift = root.querySelector('[data-offl-pieces-gift]');
  var piecesGiftColors = root.querySelector('[data-offl-pieces-gift-colors]');
  var pieces = [];            // { color, size|null (null = taille globale), touched }
  var perPieceSizes = false;
  var activePiece = -1;
  var giftSizeChoice = null;  // taille culottes choisie ; null = suit la taille du soutien-gorge (3XL→XXL)
  var giftSizeBtns = root.querySelector('[data-offl-gift-size-btns]');

  function giftSizesList() {
    // grille de tailles PROPRE au produit culotte (depuis ses variantes réelles)
    var seen = [], out = [];
    if (giftMap) Object.keys(giftMap).forEach(function (k) {
      var s = k.split('|')[1];
      if (s && seen.indexOf(s) === -1) { seen.push(s); out.push(s); }
    });
    return out;
  }
  function effectiveGiftSize() {
    if (giftSizeChoice) return giftSizeChoice;
    var s = mainSize();
    if (s === '3XL') s = 'XXL';
    var sizes = giftSizesList();
    return sizes.indexOf(s) >= 0 ? s : (sizes[0] || '');
  }

  function optionData(pos) {
    var arr = [];
    root.querySelectorAll('[data-offl-opt-input][data-offl-opt-pos="' + pos + '"]').forEach(function (i) {
      var sw = i.closest('.offl-swatch');
      var img = sw ? sw.querySelector('.offl-swatch__img') : null;
      arr.push({ name: i.value, img: img ? img.getAttribute('src') : null });
    });
    return arr;
  }
  function mainColor() { return currentSelection()[0] || ''; }
  function mainSize() { return currentSelection()[1] || ''; }
  function colHandle(name) {
    return (name || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, '-');
  }

  function giftColorsList() {
    // 3 premières couleurs DISTINCTES des pièces ; complétées par la couleur dominante
    var order = [], counts = {};
    pieces.slice(0, currentPieces).forEach(function (p) {
      var c = p.color || mainColor();
      counts[c] = (counts[c] || 0) + 1;
      if (order.indexOf(c) === -1) order.push(c);
    });
    var out = order.slice(0, currentGiftQty || 3);
    var dominant = order[0] || mainColor();
    Object.keys(counts).forEach(function (c) { if (counts[c] > (counts[dominant] || 0)) dominant = c; });
    while (out.length < (currentGiftQty || 3)) out.push(dominant);
    return out;
  }

  function renderPieces() {
    if (!piecesPanel || !piecesGrid) return;
    var show = !!currentPackVariant && currentPieces > 1;
    piecesPanel.hidden = !show;
    if (!show) return;
    var gs = mainSize();
    var html = '';
    for (var i = 0; i < currentPieces; i++) {
      var p = pieces[i] || {};
      var col = p.color || '';
      var size = p.size || gs;
      var cdata = null;
      optionData(0).forEach(function (c) { if (c.name === col) cdata = c; });
      html += '<button type="button" class="offl-piece' + (i === activePiece ? ' is-open' : '') + (col ? '' : ' is-empty') + '" data-offl-piece-btn data-piece="' + i + '" role="listitem" aria-label="Pièce ' + (i + 1) + (col ? ' : ' + col + ' taille ' + size : ' : à choisir') + '">'
        + (cdata && cdata.img ? '<img class="offl-piece__img" src="' + cdata.img + '" alt="">' : '<span class="offl-piece__img offl-piece__img--empty">?</span>')
        + '<span class="offl-piece__num">' + (i + 1) + '</span>'
        + '<span class="offl-piece__meta">' + (col ? col + ' · ' + size : '?') + '</span>'
        + '</button>';
    }
    piecesGrid.innerHTML = html;
    // compteur X/N ✓
    var filled = 0;
    for (var f = 0; f < currentPieces; f++) if ((pieces[f] || {}).color) filled++;
    if (piecesCount) {
      piecesCount.textContent = filled + '/' + currentPieces + (filled === currentPieces ? ' ✓' : '');
      piecesCount.classList.toggle('is-done', filled === currentPieces);
    }
    // palette de la pièce active
    if (piecesPalette) {
      if (activePiece >= 0 && activePiece < currentPieces) {
        var ap = pieces[activePiece] || {};
        piecesPalette.hidden = false;
        if (paletteTitle) paletteTitle.textContent = 'Pièce ' + (activePiece + 1) + ' — choisissez sa couleur';
        if (paletteColors) {
          var ch = '';
          optionData(0).forEach(function (c) {
            ch += '<button type="button" class="offl-piece-color' + (c.name === ap.color ? ' is-sel' : '') + '" data-offl-palette-color="' + c.name.replace(/"/g, '&quot;') + '" aria-label="' + c.name + '">'
              + (c.img ? '<img src="' + c.img + '" alt="">' : '<span class="offl-piece-color__dot" style="background:var(--swatch-' + colHandle(c.name) + ',#C9BFB2)"></span>')
              + '<span>' + c.name + '</span></button>';
          });
          paletteColors.innerHTML = ch;
        }
        if (paletteSizes) {
          paletteSizes.hidden = !perPieceSizes;
          if (perPieceSizes) {
            var sh = '<span class="offl-piece-sizes__lbl">Taille de cette pièce :</span>';
            optionData(1).forEach(function (s) {
              var sel = (ap.size || gs) === s.name;
              sh += '<button type="button" class="offl-piece-size' + (sel ? ' is-sel' : '') + '" data-offl-palette-size="' + s.name + '">' + s.name + '</button>';
            });
            paletteSizes.innerHTML = sh;
          }
        }
      } else {
        piecesPalette.hidden = true;
      }
    }
    // ligne cadeau live (3 culottes = couleurs des pièces) + rebond quand elle change
    if (piecesGift) {
      if (currentGiftQty > 0) {
        piecesGift.hidden = false;
        if (piecesGiftColors) {
          var gc = giftColorsList(), gh = '';
          gc.forEach(function (c) {
            gh += '<span class="offl-pieces__gift-chip"><span class="offl-pieces__gift-dot" style="background:var(--swatch-' + colHandle(c) + ',#C9BFB2)"></span>' + c + '</span>';
          });
          var sig = gc.join('|');
          if (piecesGiftColors.innerHTML !== '' && sig !== piecesGiftColors.getAttribute('data-sig')) {
            piecesGiftColors.classList.remove('offl-pop');
            void piecesGiftColors.offsetWidth; // relance l'animation
            piecesGiftColors.classList.add('offl-pop');
          }
          piecesGiftColors.setAttribute('data-sig', sig);
          piecesGiftColors.innerHTML = gh;
        }
        // sélecteur de taille dédié aux culottes (grille culotte, pas celle du soutien-gorge)
        if (giftSizeBtns) {
          var egs = effectiveGiftSize(), sh2 = '';
          giftSizesList().forEach(function (s) {
            sh2 += '<button type="button" class="offl-piece-size offl-piece-size--gift' + (s === egs ? ' is-sel' : '') + '" data-offl-gift-size-btn="' + s + '">' + s + '</button>';
          });
          giftSizeBtns.innerHTML = sh2;
        }
      } else {
        piecesGift.hidden = true;
      }
    }
  }

  // petit rebond visuel sur la case qui vient d'être personnalisée (feedback ludique)
  function popPiece(idx) {
    var cell = piecesGrid ? piecesGrid.querySelector('[data-piece="' + idx + '"]') : null;
    if (!cell) return;
    cell.classList.add('offl-pop');
    setTimeout(function () { cell.classList.remove('offl-pop'); }, 420);
  }

  function piecesSync() {
    // ajuste la longueur au palier + synchronise les pièces non personnalisées sur la couleur principale
    while (pieces.length < currentPieces) pieces.push({ color: mainColor(), size: null, touched: false });
    if (pieces.length > currentPieces) pieces.length = currentPieces;
    pieces.forEach(function (p) { if (!p.touched) p.color = mainColor(); });
    if (activePiece >= currentPieces) activePiece = -1;
    renderPieces();
  }

  if (piecesPanel) {
    piecesPanel.addEventListener('click', function (e) {
      var pb = e.target.closest('[data-offl-piece-btn]');
      if (pb) {
        var idx = parseInt(pb.getAttribute('data-piece'), 10);
        activePiece = (activePiece === idx) ? -1 : idx;
        renderPieces();
        if (activePiece >= 0 && piecesPalette && piecesPalette.scrollIntoView) {
          piecesPalette.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        return;
      }
      var cb = e.target.closest('[data-offl-palette-color]');
      if (cb && activePiece >= 0) {
        var justSet = activePiece;
        pieces[activePiece] = pieces[activePiece] || { size: null };
        pieces[activePiece].color = cb.getAttribute('data-offl-palette-color');
        pieces[activePiece].touched = true;
        // flux guidé : passe automatiquement à la pièce suivante (sauf si tailles par pièce ouvertes,
        // pour laisser choisir la taille de cette pièce)
        if (!perPieceSizes) {
          activePiece = (activePiece < currentPieces - 1) ? activePiece + 1 : -1;
        }
        renderPieces();
        popPiece(justSet);
        return;
      }
      var sb = e.target.closest('[data-offl-palette-size]');
      if (sb && activePiece >= 0) {
        pieces[activePiece] = pieces[activePiece] || {};
        pieces[activePiece].size = sb.getAttribute('data-offl-palette-size');
        pieces[activePiece].touched = true;
        renderPieces();
        return;
      }
      var gsb = e.target.closest('[data-offl-gift-size-btn]');
      if (gsb) {
        giftSizeChoice = gsb.getAttribute('data-offl-gift-size-btn');
        renderPieces();
        return;
      }
    });
  }
  if (sizesToggle) {
    sizesToggle.addEventListener('click', function () {
      perPieceSizes = !perPieceSizes;
      if (!perPieceSizes) pieces.forEach(function (p) { p.size = null; });
      sizesToggle.textContent = perPieceSizes ? (sizesToggle.getAttribute('data-lbl-close') || '') : (sizesToggle.getAttribute('data-lbl-open') || '');
      if (perPieceSizes && activePiece < 0) { activePiece = 0; }
      renderPieces();
    });
  }
  var recap = root.querySelector('[data-offl-recap]');
  var recapTxt = root.querySelector('[data-offl-recap-txt]');
  var checkedBundle = root.querySelector('[data-offl-bundle-input]:checked');
  var currentCta = checkedBundle && checkedBundle.getAttribute('data-cta') ? checkedBundle.getAttribute('data-cta') : LBL.add;
  function applyBundle(inp) {
    if (!inp) return;
    currentPieces = parseInt(inp.getAttribute('data-qty'), 10) || 1;
    currentPackVariant = inp.getAttribute('data-pack-variant') || null;
    currentPackPrice = inp.getAttribute('data-pack-price') || '';
    currentQty = currentPackVariant ? 1 : currentPieces; // pack = 1 ligne ; unité = quantité
    currentGiftQty = parseInt(inp.getAttribute('data-gift-qty'), 10) || 0;
    currentCta = inp.getAttribute('data-cta') || LBL.add;
    var card = inp.closest('.offl-bundle');
    root.querySelectorAll('.offl-bundle').forEach(function (c) {
      c.classList.toggle('is-active', c === card && inp.checked);
    });
    // récap dynamique : l'offre choisie s'affiche clairement (+ cadeau éventuel)
    if (recap && recapTxt && card) {
      var t = card.querySelector('.offl-bundle__title');
      var p = card.querySelector('.offl-bundle__price');
      var g = card.querySelector('.offl-bundle__gift > span:first-of-type');
      var txt = 'Offre choisie : ' + (t ? t.textContent.trim() : '') + (p ? ' — ' + p.textContent.trim() : '');
      if (g && currentGiftQty > 0) txt += ' + ' + g.textContent.trim().toLowerCase();
      recapTxt.textContent = txt;
      recap.hidden = false;
    }
    var v = findVariant(currentSelection());
    if (v && v.available) {
      atcText.textContent = currentCta;
      if (stickyLabel) stickyLabel.textContent = currentCta;
    }
    // le prix du sticky suit l'offre choisie (prix pack réel, sinon prix unitaire)
    if (stickyPrice) {
      if (currentPackVariant && currentPackPrice) stickyPrice.textContent = currentPackPrice;
      else if (v) stickyPrice.textContent = v.price_formatted;
    }
    // resynchronise la miniature du lot (visible seulement si l'offre est cochée)
    refreshBundlePricing(v);
    // panneau de personnalisation par pièce (packs uniquement)
    piecesSync();
  }

  // ---- Extras des cartes d'offres : miniature du lot de culottes offert (aucun calcul de prix ici,
  //      les prix affichés sont rendus côté serveur depuis les vraies variantes ; zéro barré fictif) ----
  function refreshBundlePricing(v) {
    root.querySelectorAll('[data-offl-bundle-input]').forEach(function (inp) {
      var card = inp.closest('.offl-bundle');
      if (!card) return;
      var gq = parseInt(inp.getAttribute('data-gift-qty'), 10) || 0;
      // visuel du lot offert : image du coloris sélectionné, visible seulement quand l'offre est cochée
      var wrap = card.querySelector('[data-offl-gift-imgwrap]');
      if (wrap && gq > 0 && inp.checked) {
        var sel = currentSelection();
        var col = sel[0];
        var img = wrap.querySelector('[data-offl-gift-img]');
        var nameEl = wrap.querySelector('[data-offl-gift-imgname]');
        var url = (lotImgMap && col) ? lotImgMap[col] : null;
        if (url && img) {
          if (img.getAttribute('src') !== url) img.src = url;
          img.alt = 'Lot de ' + gq + ' culottes assorties offertes — coloris ' + col;
          if (nameEl) nameEl.textContent = gq + ' culottes assorties · ' + col;
          wrap.hidden = false;
        } else {
          wrap.hidden = true;
        }
      } else if (wrap) {
        wrap.hidden = true;
      }
    });
  }

  function currentSelection() {
    var inputs = root.querySelectorAll('[data-offl-opt-input]:checked');
    var sel = [];
    inputs.forEach(function (i) { sel[parseInt(i.getAttribute('data-offl-opt-pos'), 10)] = i.value; });
    return sel;
  }

  function findVariant(sel) {
    return variants.find(function (v) {
      return v.options.length === sel.length && v.options.every(function (o, idx) { return o === sel[idx]; });
    });
  }

  // ---- Lazy galerie : l'image d'une slide ne se charge que lorsqu'elle devient active (+ précharge la suivante) ----
  function loadSlideImg(slide) {
    if (!slide) return;
    var img = slide.querySelector('img[data-offl-lazy]');
    if (!img) return;
    var ss = img.getAttribute('data-offl-lazyset'); if (ss) img.setAttribute('srcset', ss);
    img.setAttribute('src', img.getAttribute('data-offl-lazy'));
    img.removeAttribute('data-offl-lazy'); img.removeAttribute('data-offl-lazyset');
  }
  function ensureSlideLoaded(slide) {
    if (!slide) return;
    loadSlideImg(slide);
    var nx = slide.nextElementSibling;
    while (nx && !nx.hasAttribute('data-offl-slide')) nx = nx.nextElementSibling;
    if (!nx) return;
    // La precharge de la slide suivante attend que la page soit affichee.
    // Avant : elle partait des le premier rendu et volait ~70 Ko de bande passante
    // a l'image principale, en priorite haute, pile pendant le LCP (28/07).
    if (document.readyState === 'complete') { loadSlideImg(nx); return; }
    window.addEventListener('load', function () {
      setTimeout(function () { loadSlideImg(nx); }, 300);
    }, { once: true });
  }

  function setMedia(mediaId) {
    if (!mediaId) return;
    slides.forEach(function (s) {
      var on = s.getAttribute('data-media-id') == mediaId;
      s.classList.toggle('is-active', on);
      if (on) ensureSlideLoaded(s);
    });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') == mediaId); });
  }
  // au chargement : garantit que la slide active de départ (+ la suivante) est chargée
  (function () { var a = root.querySelector('[data-offl-slide].is-active'); if (a) ensureSlideLoaded(a); })();

  function update() {
    var sel = currentSelection();
    // reflète la valeur sélectionnée dans le legend
    root.querySelectorAll('[data-offl-optval]').forEach(function (span) {
      var pos = parseInt(span.getAttribute('data-offl-optval'), 10);
      if (sel[pos]) span.textContent = sel[pos];
    });
    // met à jour l'état actif visuel des swatches
    root.querySelectorAll('[data-offl-opt-input]').forEach(function (i) {
      i.closest('.offl-swatch').classList.toggle('is-active', i.checked);
    });

    var v = findVariant(sel);
    if (!v) {
      atc.disabled = true;
      atcText.textContent = LBL.unavailable;
      if (stickyLabel) stickyLabel.textContent = LBL.unavailable;
      return;
    }
    variantInput.value = v.id;
    // prix
    priceEl.textContent = v.price_formatted;
    if (stickyPrice) stickyPrice.textContent = v.price_formatted;
    if (v.compare_at && v.compare_at > v.price) {
      compareEl.textContent = v.compare_formatted; compareEl.hidden = false;
      if (saveEl) { saveEl.textContent = (saveEl.getAttribute('data-lbl') || '') + ' ' + formatMoney(v.compare_at - v.price); saveEl.hidden = false; }
    } else {
      compareEl.hidden = true;
      if (saveEl) saveEl.hidden = true;
    }
    // média
    setMedia(v.media_id);
    // prix des cartes d'offres recalculés sur la variante réelle (+ récap via applyBundle)
    refreshBundlePricing(v);
    var chk = root.querySelector('[data-offl-bundle-input]:checked');
    if (chk) applyBundle(chk);
    // dispo
    if (v.available) {
      atc.disabled = false; atcText.textContent = currentCta || LBL.add;
      if (stickyLabel) stickyLabel.textContent = currentCta || LBL.add;
    } else {
      atc.disabled = true; atcText.textContent = LBL.sold;
      if (stickyLabel) stickyLabel.textContent = LBL.sold;
    }
    // NB : le prix du sticky est déjà géré par applyBundle (L305) : prix du pack si une offre pack est active, sinon prix unitaire.
    // (Bloc retiré le 2026-07-24 : il ré-écrasait le prix du pack par le prix unitaire dès qu'un compare_at existait — toujours le cas sur FLOW, 34,99 barré 39,99 — figeant le sticky à 34,99 € alors que le pack ajouté valait 89,90 €.)
    hideError();
  }

  // formatage monnaie basique à partir de la string existante (reprend le format du thème via le 1er prix rendu)
  var moneyFmt = (priceEl.textContent.match(/[^\d\s.,-]+/g) || ['€']);
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    // conserve le symbole tel que rendu par Shopify (avant ou après)
    var raw = priceEl.getAttribute('data-raw') || priceEl.textContent;
    if (/^\s*[^\d]/.test(raw)) return raw.replace(/[\d.,\s]+/, ' ' + amount + ' ').trim();
    return amount + ' ' + (raw.replace(/[\d.,\s]/g, '') || '€');
  }

  function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
  function hideError() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }

  // écoute les changements d'option
  root.querySelectorAll('[data-offl-opt-input]').forEach(function (i) {
    i.addEventListener('change', update);
  });
  if (saveEl) saveEl.setAttribute('data-lbl', (saveEl.textContent.split(/\d/)[0] || '').trim());

  // ---- Ajout au panier (AJAX + ouverture du drawer du thème si présent) ----
  // Variante culotte pour une couleur donnée (3XL → XXL, la culotte s'arrête au XXL ;
  // si la taille exacte manque, on prend la première taille disponible du coloris)
  function giftVariantFor(col, size) {
    if (!giftMap || !col) return null;
    if (size === '3XL') size = 'XXL';
    var g = size ? giftMap[col + '|' + size] : null;
    if (g && g.available) return g.id;
    var found = null;
    Object.keys(giftMap).forEach(function (k) {
      if (!found && k.indexOf(col + '|') === 0 && giftMap[k].available) found = giftMap[k].id;
    });
    return found;
  }

  function addToCart(id) {
    atc.classList.add('is-loading');
    var items = [];
    var gs = mainSize();
    if (currentPackVariant) {
      // palier pack : 1 ligne à prix fixe réel.
      // Panier lisible : 1 seule ligne « Contenu » groupée (2× Noir · M …) ;
      // le détail pièce par pièce part en propriétés _masquées (visibles en admin pour la préparation).
      var props = {};
      var comboOrder = [], comboCounts = {};
      for (var p = 0; p < currentPieces; p++) {
        var pc = pieces[p] || {};
        var label = (pc.color || mainColor() || '') + ' · ' + (pc.size || gs || '');
        if (!comboCounts[label]) { comboCounts[label] = 0; comboOrder.push(label); }
        comboCounts[label]++;
        props['_Pièce ' + (p + 1)] = (pc.color || mainColor() || '') + ' / ' + (pc.size || gs || '');
      }
      props['Contenu'] = comboOrder.map(function (l) { return comboCounts[l] + '× ' + l; }).join('  ·  ');
      // culottes offertes AVANT le pack : Shopify affiche le dernier ajout en premier,
      // le produit principal payé reste donc en haut du panier
      if (currentGiftQty > 0) {
        var counts = {};
        giftColorsList().forEach(function (c) { counts[c] = (counts[c] || 0) + 1; });
        var gsize = effectiveGiftSize();
        Object.keys(counts).forEach(function (c) {
          var gid = giftVariantFor(c, gsize);
          if (gid) items.push({ id: gid, quantity: counts[c] });
        });
      }
      items.push({ id: parseInt(currentPackVariant, 10), quantity: 1, properties: props });
    } else {
      items.push({ id: parseInt(id, 10), quantity: currentQty || 1 });
    }
    var _dc = document.querySelector('cart-drawer-component');
    var _dsEl = _dc && _dc.closest('[id^="shopify-section-"]');
    var _drawerSid = _dsEl ? _dsEl.id.replace('shopify-section-', '') : null;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(_drawerSid ? { items: items, sections: _drawerSid, sections_url: window.location.pathname } : { items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Erreur panier'); });
      return r.json();
    }).then(function (data) {
      atc.classList.remove('is-loading');
      openCartDrawer(data && data.sections);
    }).catch(function (e) {
      atc.classList.remove('is-loading');
      showError(e.message || 'Impossible d’ajouter au panier.');
    });
  }

  function openCartDrawer(preSections) {
    var comp = document.querySelector('cart-drawer-component');
    if (!comp || typeof comp.open !== 'function') { window.location.href = '/cart'; return; }
    var sectionEl = comp.closest('[id^="shopify-section-"]');
    var sid = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
    function openIt() { try { comp.open(); } catch (e) { window.location.href = '/cart'; } }
    function applyHtml(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshDialog = doc.querySelector('cart-drawer-component dialog');
      var liveDialog = comp.querySelector('dialog');
      if (freshDialog && liveDialog) { liveDialog.innerHTML = freshDialog.innerHTML; }
      var freshBubble = doc.querySelector('.cart-bubble');
      var liveBubble = document.querySelector('.cart-bubble');
      if (freshBubble && liveBubble) { liveBubble.innerHTML = freshBubble.innerHTML; liveBubble.classList.toggle('visually-hidden', freshBubble.classList.contains('visually-hidden')); }
    }
    // chemin rapide : le HTML du drawer est déjà revenu avec /cart/add.js (1 seul aller-retour)
    if (preSections && sid && preSections[sid]) { applyHtml(preSections[sid]); openIt(); return; }
    if (!sid) { openIt(); return; }
    // repli : Section Rendering séparé
    fetch('/?sections=' + encodeURIComponent(sid)).then(function (r) { return r.json(); }).then(function (j) {
      applyHtml(j[sid]); openIt();
    }).catch(function () { openIt(); });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // sans fetch, submit natif → /cart
      e.preventDefault();
      hideError();
      addToCart(variantInput.value);
    });
  }
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (atc.disabled) return;
      if (!window.fetch) { form.submit(); return; }
      addToCart(variantInput.value);
    });
  }

  // ---- Galerie ----
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { setMedia(t.getAttribute('data-media-id')); });
  });

  // ---- Flèches navigation galerie ----
  var galList = Array.prototype.slice.call(slides);
  function galGo(dir) {
    if (!galList.length) return;
    var idx = -1;
    for (var i = 0; i < galList.length; i++) { if (galList[i].classList.contains('is-active')) { idx = i; break; } }
    if (idx < 0) idx = 0;
    var n = (idx + dir + galList.length) % galList.length;
    var mid = galList[n].getAttribute('data-media-id');
    setMedia(mid);
    var at = root.querySelector('[data-offl-thumb][data-media-id="' + mid + '"]');
    if (at && at.scrollIntoView) at.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  var galPrev = root.querySelector('[data-offl-prev]');
  var galNext = root.querySelector('[data-offl-next]');
  if (galPrev) galPrev.addEventListener('click', function (e) { e.preventDefault(); galGo(-1); });
  if (galNext) galNext.addEventListener('click', function (e) { e.preventDefault(); galGo(1); });
  // ---- Swipe tactile sur l'image principale ----
  var galMain = root.querySelector('[data-offl-main]');
  if (galMain) {
    var tx = 0, ty = 0;
    galMain.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; ty = e.changedTouches[0].clientY; }, { passive: true });
    galMain.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) galGo(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  // ---- Sticky : persistant dès l'arrivée sur la page (toujours visible) ----
  if (sticky) {
    sticky.classList.add('is-visible');
    sticky.setAttribute('aria-hidden', 'false');
  }
  // ---- Offres / bundles : sélection → CTA + quantité ----
  root.querySelectorAll('[data-offl-bundle-input]').forEach(function (inp) {
    inp.addEventListener('change', function () { applyBundle(inp); });
  });
  if (checkedBundle) applyBundle(checkedBundle);

  // ---- Urgence expédition animée (compte à rebours + estimation livraison, honnête) ----
  (function () {
    var urg = root.querySelector('[data-offl-urgency]');
    if (!urg) return;
    var cutoffH = parseInt(urg.getAttribute('data-cutoff'), 10) || 16;
    var minD = parseInt(urg.getAttribute('data-min'), 10) || 2;
    var maxD = parseInt(urg.getAttribute('data-max'), 10) || 4;
    var leadEl = urg.querySelector('[data-offl-urgency-lead]');
    var etaEl = urg.querySelector('[data-offl-urgency-eta]');
    var MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    var DAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    function two(n) { return (n < 10 ? '0' : '') + n; }
    function addBiz(from, n) { var d = new Date(from); var a = 0; while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; }
    function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
    function tick() {
      var now = new Date();
      var w = now.getDay();
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffH, 0, 0);
      if (w !== 0 && w !== 6 && now < cutoff) {
        var r = Math.floor((cutoff - now) / 1000);
        var h = Math.floor(r / 3600), m = Math.floor((r % 3600) / 60), s = r % 60;
        leadEl.innerHTML = 'Commandez dans <b>' + two(h) + ':' + two(m) + ':' + two(s) + '</b> pour partir au prochain envoi';
      } else {
        leadEl.innerHTML = 'Commandez maintenant — départ au prochain jour ouvré';
      }
      var d1 = new Date(now); d1.setDate(d1.getDate() + minD);
      var d2 = new Date(now); d2.setDate(d2.getDate() + maxD);
      etaEl.innerHTML = 'Livraison estimée entre le <b>' + fmt(d1) + '</b> et le <b>' + fmt(d2) + '</b> · expédié sous 2 jours';
    }
    tick();
    setInterval(tick, 1000);
  })();

  // ---- Carrousel d'avis (colonne d'achat) : flèches + swipe natif ----
  (function () {
    var vcar = root.querySelector('[data-offl-vcar]');
    if (!vcar) return;
    var track = vcar.querySelector('[data-offl-vcar-track]');
    var prev = vcar.querySelector('[data-offl-vcar-prev]');
    var next = vcar.querySelector('[data-offl-vcar-next]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.offl-vcard');
      return card ? card.getBoundingClientRect().width + 10 : track.clientWidth;
    }
    function syncArrows() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () {
      if (track._t) clearTimeout(track._t);
      track._t = setTimeout(syncArrows, 90);
    }, { passive: true });
    syncArrows();
    window.addEventListener('resize', syncArrows);
    // au 1er rendu les images ne sont pas encore chargées : scrollWidth == clientWidth,
    // les flèches naîtraient désactivées et ne se réactiveraient jamais → resynchroniser
    window.addEventListener('load', syncArrows);
    if ('ResizeObserver' in window) new ResizeObserver(syncArrows).observe(track);
    track.querySelectorAll('img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', syncArrows, { once: true });
    });
  })();

  // ---- Modal guide des tailles ----
  var sgModal = root.querySelector('[data-offl-sizeguide]');
  if (sgModal) {
    // sort le modal de tout contexte d'empilement parent (header, etc.)
    if (sgModal.parentElement !== document.body) document.body.appendChild(sgModal);
    var openSG = function () { sgModal.hidden = false; document.body.classList.add('offl-modal-open'); var c = sgModal.querySelector('.offl-modal__close'); if (c) c.focus(); };
    var closeSG = function () { sgModal.hidden = true; document.body.classList.remove('offl-modal-open'); };
    // délégation : boutons dédiés + lien dans l'accordéon (richtext) href="#offl-guide-tailles"
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-offl-sizeguide-open], a[href="#offl-guide-tailles"]');
      if (t) { e.preventDefault(); openSG(); }
    });
    sgModal.querySelectorAll('[data-offl-sizeguide-close]').forEach(function (b) { b.addEventListener('click', closeSG); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sgModal.hidden) closeSG(); });

    // ---- Size finder interactif (dans le modal) ----
    (function () {
      var finder = sgModal.querySelector('.finder-box');
      if (!finder) return;
      var scope = sgModal;
      var MATRIX = { AA:{80:'S',85:'S',90:'S',95:'M',100:'M',105:'L',110:'L'}, A:{80:'S',85:'S',90:'M',95:'M',100:'L',105:'L',110:'XL'}, B:{80:'S',85:'S',90:'M',95:'M',100:'L',105:'XL',110:'XL'}, C:{80:'M',85:'M',90:'L',95:'L',100:'XL',105:'XL',110:'XXL'}, D:{80:'M',85:'M',90:'L',95:'L',100:'XL',105:'XXL',110:'XXL'}, E:{80:'L',85:'L',90:'XL',95:'XL',100:'XXL',105:'3XL',110:'3XL'}, F:{80:'XL',85:'XL',90:'XXL',95:'XXL',100:'3XL',105:'3XL',110:'3XL'} };
      var INTL = { S:{FR:'36',EU:'36',UK:'8',US:'4'}, M:{FR:'38',EU:'38',UK:'10',US:'6'}, L:{FR:'40',EU:'40',UK:'12',US:'8'}, XL:{FR:'42',EU:'42',UK:'14',US:'10'}, XXL:{FR:'44',EU:'44',UK:'16',US:'12'}, '3XL':{FR:'46',EU:'46',UK:'18',US:'14'} };
      var TCOL = {80:0,85:1,90:2,95:3,100:4,105:5,110:6}, BROW = {AA:0,A:1,B:2,C:3,D:4,E:5,F:6};
      var selT = null, selB = null;
      function upd() {
        var sz = scope.querySelector('#result-size'), sub = scope.querySelector('#result-sub'), intl = scope.querySelector('#result-intl');
        scope.querySelectorAll('.bonnet-table tbody td').forEach(function (td) { td.classList.remove('highlight-col', 'highlight-both'); });
        scope.querySelectorAll('.bonnet-table thead th').forEach(function (th) { th.classList.remove('highlight-col'); });
        scope.querySelectorAll('.bonnet-table tbody tr').forEach(function (tr) { tr.classList.remove('highlight-row'); });
        if (!selT || !selB) { sz.textContent = 'Sélectionnez tour + bonnet'; sz.className = 'result-size pending'; sub.textContent = ''; intl.innerHTML = ''; return; }
        var taille = MATRIX[selB][selT], ci = TCOL[selT], ri = BROW[selB];
        var hth = scope.querySelector('.bonnet-table thead tr:first-child th[data-col="' + ci + '"]'); if (hth) hth.classList.add('highlight-col');
        var row = scope.querySelector('.bonnet-table tbody tr[data-row="' + ri + '"]'); if (row) row.classList.add('highlight-row');
        scope.querySelectorAll('.bonnet-table tbody td[data-col="' + ci + '"]').forEach(function (td) { td.classList.add('highlight-col'); });
        var cell = scope.querySelector('.bonnet-table tbody tr[data-row="' + ri + '"] td[data-col="' + ci + '"]'); if (cell) { cell.classList.remove('highlight-col'); cell.classList.add('highlight-both'); }
        if (!taille) { sz.textContent = 'Combinaison non disponible'; sz.className = 'result-size na'; sub.textContent = 'Cette combinaison n’est pas couverte par ce modèle. Contactez-nous.'; intl.innerHTML = ''; }
        else { sz.textContent = taille; sz.className = 'result-size'; sub.textContent = 'Tour ' + selT + ' cm · Bonnet ' + selB; var i = INTL[taille]; intl.innerHTML = '<span class="intl-pill">FR ' + i.FR + '</span><span class="intl-pill">EU ' + i.EU + '</span><span class="intl-pill">UK ' + i.UK + '</span><span class="intl-pill">US ' + i.US + '</span>'; }
      }
      // Bouton d'application : sans lui, la cliente doit retenir sa taille,
      // fermer la fenetre et re-cliquer elle-meme dans le selecteur (29/07).
      var applique = null;
      function boutonAppliquer() {
        if (applique) return applique;
        var res = scope.querySelector('.finder-result');
        if (!res) return null;
        applique = document.createElement('button');
        applique.type = 'button';
        applique.className = 'finder-apply';
        applique.hidden = true;
        res.appendChild(applique);
        applique.addEventListener('click', function () {
          var t = applique.getAttribute('data-taille');
          if (!t) return;
          var inputs = root.querySelectorAll('[data-offl-opt-input]');
          for (var i = 0; i < inputs.length; i++) {
            var inp = inputs[i];
            if (inp.getAttribute('data-offl-opt-pos') === '1' && inp.value === t) {
              inp.checked = true;
              inp.dispatchEvent(new Event('change', { bubbles: true }));
              var lab = inp.closest('.offl-swatch');
              if (lab) {
                var freres = lab.parentElement.querySelectorAll('.offl-swatch');
                for (var k = 0; k < freres.length; k++) freres[k].classList.remove('is-active');
                lab.classList.add('is-active');
              }
              break;
            }
          }
          closeSG();
          var fs = root.querySelector('[data-offl-size-match]') || root.querySelector('.offl-atc');
          if (fs && fs.scrollIntoView) { try { fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {} }
        });
        return applique;
      }
      function majBouton(taille) {
        var b = boutonAppliquer();
        if (!b) return;
        if (!taille) { b.hidden = true; b.removeAttribute('data-taille'); return; }
        b.hidden = false;
        b.setAttribute('data-taille', taille);
        b.textContent = 'Choisir la taille ' + taille;
      }

      finder.addEventListener('click', function (e) {
        var b = e.target.closest('.finder-btn'); if (!b) return;
        if (b.dataset.tour) { scope.querySelectorAll('#btns-tour .finder-btn').forEach(function (x) { x.classList.remove('selected'); }); b.classList.add('selected'); selT = b.dataset.tour; }
        else if (b.dataset.bonnet) { scope.querySelectorAll('#btns-bonnet .finder-btn').forEach(function (x) { x.classList.remove('selected'); }); b.classList.add('selected'); selB = b.dataset.bonnet; }
        upd();
        majBouton((selT && selB) ? MATRIX[selB][selT] : null);
      });
    })();
  }

  // ---- Rappel des tailles de soutien-gorge couvertes par la taille selectionnee ----
  (function () {
    var cible = root.querySelector('[data-offl-size-match]');
    if (!cible) return;
    var COUVRE = {
      'S':   ['80AA','80A','80B','85AA','85A','85B','90AA'],
      'M':   ['80C','80D','85C','85D','90A','90B','95AA','95A','95B','100AA'],
      'L':   ['80E','85E','90C','90D','95C','95D','100A','100B','105AA','105A','110AA'],
      'XL':  ['80F','85F','90E','95E','100C','100D','105B','105C','110A','110B'],
      'XXL': ['90F','95F','100E','105D','110C','110D'],
      '3XL': ['100F','105E','105F','110E','110F']
    };
    function normalise(v) {
      var t = String(v || '').trim().toUpperCase().replace(/\s+/g, '');
      if (t === '2XL') t = 'XXL';
      if (t === 'XXXL') t = '3XL';
      return t;
    }
    function rendu() {
      var champ = root.querySelector('fieldset.offl-opt:has([data-offl-size-match]) input[data-offl-opt-input]:checked');
      if (!champ) {
        var fs = cible.closest('fieldset');
        champ = fs ? fs.querySelector('input[data-offl-opt-input]:checked') : null;
      }
      if (!champ) { cible.textContent = ''; return; }
      var liste = COUVRE[normalise(champ.value)];
      if (!liste) { cible.textContent = ''; return; }
      cible.innerHTML = 'Cette taille correspond aux soutiens-gorge <b>' + liste.join(' · ') + '</b>.';
    }
    root.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-offl-opt-input')) rendu();
    });
    rendu();
  })();

  update();
})();
